var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyInsurancesList',{attrs:{"portfolio-info":_vm.portfolioInfo,"text-content":_vm.textContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }